<script lang="ts" setup>
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import PageHeader from '@/components/global/page-header/PageHeader.vue'
import CustomerForm from '@/components/features/customers/CustomerForm.vue'
import OrderHistory from '@/components/features/customers/OrderHistory.vue'
import LinkedProducts from '@/components/features/customers/LinkedProducts.vue'
import type { ErrorResponse } from '@/types/error-types'
import { editCustomer } from '@/api/customers'
import { useCustomerForm } from '@/composables/useCustomerForm'
import { orderHistoryData } from '@/constants/customers'
import { useRouter } from 'vue-router'

const {
  values,
  handleSubmit,
  addressFields,
  newAddress,
  removeAddress,
  setErrors,
  showToast,
  formType,
  meta,
  loading
} = useCustomerForm('edit')

const router = useRouter()

const onSubmit = handleSubmit(() => {
  loading.value = true
  const addresses =
    values?.addresses?.map((address: any) => ({
      ...address,
      country: address?.country,
      location: address?.location?.id,
      addressType: address?.addressType?.id
    })) || []

  editCustomer(
    {
      ...values,
      addresses
    },
    values.id
  )
    .then(() => {
      loading.value = false
      showToast('info', 'Customer Edited!', 'You have successfully edited customer.')
      router.push(`/customers/${values?.id}`)
    })
      .catch((error: { response?: { data: ErrorResponse } }) => {
        loading.value = false
        const errorMessages = error.response?.data?.errors?.map((err) => err.description).join('\n') || 'Unable to edit customer.'
        showToast('error', 'An error occurred!', errorMessages)
      })
})
</script>

<template>
  <PageHeader
    title="Edit Customer"
    buttonText="Save Changes"
    buttonIcon="material-symbols:save"
    :buttonClick="onSubmit"
    :buttonDisabled="!meta.dirty"
  />

  <TabView class="bg-white rounded-md">
    <TabPanel header="Customer Details">
      <CustomerForm
        :type="formType"
        :values="values"
        :onSubmit="onSubmit"
        :addressFields="addressFields"
        :newAddress="newAddress"
        :removeAddress="removeAddress"
        :setErrors="setErrors"
        :show-toast="showToast"
      />
    </TabPanel>
    <TabPanel header="Order History">
      <OrderHistory :orderHistory="orderHistoryData" />
    </TabPanel>

    <TabPanel header="Linked Products">
      <LinkedProducts />
    </TabPanel>
  </TabView>
</template>
<style></style>
